'use strict';

// Import our module information.
import actions from './actions';
import mutations from './mutations';

// Specify state for this module.
const state = {

	// Whether or not the page should be displaying an FPS tracker.
	debug: false
};

// Return the module prepared for use.
export default {
  namespaced: true,
  state,
  actions,
  mutations
};
